module.exports = __webpack_public_path__ + "img/52114127_L.52d8d144.png";